import { createFileRoute } from '@tanstack/react-router';
import { AdminFxPage } from '../../features/catalogue';

export const Route = createFileRoute('/admin/catalogue/fx')({ component: AdminFxPage });
